import { render, staticRenderFns } from "./chatBox.vue?vue&type=template&id=caaed324"
import script from "./chatBox.vue?vue&type=script&lang=js"
export * from "./chatBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports